import { trackAction } from 'app/shared/utils/tracking';

export const defaultVehicleListSizeMap: Record<string, number> = {
  sm: 3,
  md: 2,
  lg: 3,
  xl: 3,
};

export const handleCTATracking = (): void => {
  trackAction('reduced_price_cartile_button_click', {
    category: 'home',
    label: 'reduced_price',
  });
};
